import React, { Suspense } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import { ReactQueryConfigProvider, ReactQueryConfig } from 'react-query';
import Loading from '../../junction/components/loading/Loading';
import HomeBlobs from '../components/Blobs/HomeBlobs';
import { JunctionThemeProvider } from '../../junction/utils';

type Props = {
  routes?: any[];
  children?: any;
};

const queryConfig: ReactQueryConfig = {
  queries: {
    refetchOnWindowFocus: false,
    retry: 0,
  },
};

function AppContainer(props: Props) {
  return (
    <JunctionThemeProvider.Provider value='junction'>
      <ReactQueryConfigProvider config={queryConfig}>
        <div className='lm-font-body lm-h-full'>
          <Router>{props.children}</Router>
        </div>
      </ReactQueryConfigProvider>
    </JunctionThemeProvider.Provider>
  );
}

export default AppContainer;
